import { getI18nInstance } from '@/lang'

/**
 * 友好的翻译函数
 * @param {string} key - 翻译的 key
 * @param {string} defaultValue - 默认值（当翻译缺失时使用）
 * @param {object} values - 插值参数（可选）
 * @returns {string} 翻译后的文本
 *
 * @example
 * t('global.query', '查询') // 返回当前语言的翻译或默认值
 * t('role.roleName', '角色名称', { name: 'Admin' }) // 带插值
 */
export function t(key, defaultValue, values = {}) {
  if (!key) {
    return defaultValue || ''
  }

  try {
    // 获取已初始化的 i18n 实例
    const i18n = getI18nInstance()

    // 如果 i18n 还未初始化，直接返回默认值
    if (!i18n) {
      console.warn('[i18n] Instance not initialized yet, using default value for key:', key)
      return defaultValue || key
    }

    const localeMessage = i18n.getLocaleMessage(i18n.locale)
    if (localeMessage && Object.prototype.hasOwnProperty.call(localeMessage, key)) {
      return localeMessage[key]
    }

    // 尝试使用 i18n 翻译
    const translated = i18n.t(key, values)

    // 如果翻译结果等于 key 本身，说明没有找到翻译
    if (translated === key) {
      return defaultValue || key
    }

    return translated
  } catch (error) {
    console.warn(`[i18n] Translation error for key "${key}":`, error)
    return defaultValue || key
  }
}

/**
 * 批量翻译函数
 * @param {array} keys - key 数组，每个元素可以是 string 或 {key, default} 对象
 * @returns {array} 翻译后的数组
 *
 * @example
 * tm(['global.query', 'global.reset'])
 * tm([{key: 'custom.key', default: '自定义'}，'global.query'])
 */
export function tm(keys) {
  if (!Array.isArray(keys)) {
    console.warn('[i18n] tm function requires an array')
    return []
  }

  return keys.map(item => {
    if (typeof item === 'string') {
      return t(item, item)
    } else if (typeof item === 'object' && item.key) {
      return t(item.key, item.default || item.key)
    }
    return item
  })
}

export default t
